module.exports = __webpack_public_path__ + "static/huge_thing_logo@3x-8d4ba8447c4da44247912194dc97cda2.png";